/**
 * Region detection for Kincern
 * Detects US visitors and toggles content blocks marked with
 * data-region="default" / data-region="us".
 * Manual override for testing: append ?region=US or ?region=GB to URL.
 */
(function () {
  if (window.__kcRegionDetectInit) return;
  window.__kcRegionDetectInit = true;

  var SESSION_KEY = 'kc_region';

  function applyRegion(country) {
    var isUS = country === 'US';
    var nodes = document.querySelectorAll('[data-region]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var region = el.getAttribute('data-region');
      if (region === 'us') el.hidden = !isUS;
      else if (region === 'default') el.hidden = isUS;
    }
  }

  function detect() {
    if (!document.querySelector('[data-region]')) return;

    try {
      var override = new URLSearchParams(window.location.search).get('region');
      if (override) { applyRegion(override.toUpperCase()); return; }
    } catch (e) {}

    try {
      var cached = sessionStorage.getItem(SESSION_KEY);
      if (cached) { applyRegion(cached); return; }
    } catch (e) {}

    fetch('https://www.cloudflare.com/cdn-cgi/trace', { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var match = text.match(/loc=([A-Z]{2})/);
        var country = match ? match[1] : '';
        try { sessionStorage.setItem(SESSION_KEY, country); } catch (e) {}
        applyRegion(country);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detect);
  } else {
    detect();
  }
})();